import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import OfferCard from 'containers/TransactionManagerTimeLine/OfferRegulation/OfferCard';
import RegulationCard from 'containers/TransactionManagerTimeLine/OfferRegulation/RegulationCard';
import {
  filterBeneficiariesWithRegulations,
  formatCorpoRegulationIds,
  getEvaluationByKey,
} from 'containers/TransactionManagerTimeLine/OfferRegulation/utils';
import { useSelector } from 'react-redux';
import { makeSelectRegulation } from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { ButtonContainer } from 'containers/TransactionManagerTimeLine/OfferRegulation/styles';
import { translate } from 'containers/services/translate';
import { isMinorVictim } from 'containers/PreOpeningPage/utils';
import EmptyStateTutor from 'containers/TransactionManagerTimeLine/OfferRegulation/EmptyStateTutor';
import { VictimType, TransactionType } from 'typings/globalTypes';
import { ClaimRecapType } from 'typings/claimTypes';

export interface OfferRegulationProps {
  intl: IntlShape;
  victim: VictimType;
  listings: any;
  transactionId: number;
  claimId: number;
  resetStoreTransaction: Function;
  claimNumber: string;
  riskKey: string;
  isConsultation: boolean;
  sagisInfo: any;
  transactionInfo: TransactionType;
  requestGetDahirAmount: Function;
  dahirAmount: any;
  claimInfo: ClaimRecapType;
  policyInfo: any;
  requestCreateCorporealRegulation: Function;
  requestGetRegulations: Function;
  regulations: any;
  requestSagisClaimInfo: Function;
  requestGetRegulation: Function;
  requestValidateRegulation: Function;
  resetUploadedDocument: Function;
  uploadDocument: Function;
  uploadedDocument: any;
  requestAddQuotationDocument?: Function;
  requestGetDocByDocumentumId: Function;
  isIntervenant?: boolean;
}

const OfferRegulation: React.FC<OfferRegulationProps> = (
  props,
): JSX.Element => {
  const corpoRegulation = useSelector(makeSelectRegulation()) || [];
  const [openRegulation, setOpenRegulation] = useState(false);
  const victimId = get(props.transactionInfo, 'victim.id');
  const injuryPostKey = get(props.transactionInfo, 'victim.injuryPostKey');
  const victimKey = get(props.transactionInfo, 'victim.victimKey');
  useEffect(() => {
    if (victimId) {
      const victimkeys = injuryPostKey !== '2' ? [victimKey] : [];

      const deceasedVictimkeys = injuryPostKey === '2' ? [victimKey] : [];

      props.requestGetDahirAmount(victimkeys, deceasedVictimkeys);
      props.requestGetRegulation(victimId, true);
    }

    if (props.requestGetRegulations && props.claimId) {
      props.requestGetRegulations(props.claimId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [victimId]);

  const handleOpenRegulationForm = () => {
    setOpenRegulation(true);
  };

  return (
    <>
      {!props.isConsultation &&
        isEmpty(get(props.transactionInfo, 'tutorInfo', {})) &&
        isMinorVictim(
          get(props.transactionInfo, 'victim'),
          get(props.claimInfo, 'claim.lossDate'),
        ) && (
          <EmptyStateTutor
            transactionId={get(props.transactionInfo, 'id', null)}
            claimId={props.claimId}
            victimId={get(props.transactionInfo, 'victimId', null)}
          />
        )}
      {!isEmpty(get(props.transactionInfo, 'transactionQuotation', {})) &&
        (isMinorVictim(
          get(props.transactionInfo, 'victim'),
          get(props.claimInfo, 'claim.lossDate'),
        )
          ? !isEmpty(get(props.transactionInfo, 'tutorInfo', {}))
          : true) && (
          <OfferCard
            listings={props.listings}
            claimNumber={props.claimNumber}
            transactionInfo={props.transactionInfo}
            isReadOnly={props.isConsultation}
            offerInfo={{
              ...get(props.transactionInfo, 'transactionQuotation'),
              ...getEvaluationByKey(
                get(
                  props.transactionInfo,
                  'transactionQuotation.evaluationKey',
                ),
                props.dahirAmount,
              ),
            }}
            claimInfo={props.claimInfo}
            policyInfo={props.policyInfo}
            resetUploadedDocument={props.resetUploadedDocument}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            requestAddQuotationDocument={props.requestAddQuotationDocument}
            claimId={props.claimId}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
      {!props.isConsultation &&
        !isEmpty(
          filterBeneficiariesWithRegulations(
            get(props.sagisInfo, 'regulations'),
            formatCorpoRegulationIds(corpoRegulation),
            get(props.transactionInfo, 'victim.victimKey', {}),
            get(props.transactionInfo, 'victim.beneficiaries', []).filter(
              (el: any) => !isNil(el.nextOfKinKey),
            ),
          ),
        ) &&
        !isEmpty(get(props.sagisInfo, 'regulations', [])) && (
          <ButtonContainer>
            <PrimaryButton
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.addRegulationTilte, props)}
              onClick={handleOpenRegulationForm}
            />
          </ButtonContainer>
        )}
      {!props.isConsultation &&
        !isEmpty(get(props.transactionInfo, 'transactionQuotation', {})) &&
        (isMinorVictim(
          get(props.transactionInfo, 'victim'),
          get(props.claimInfo, 'claim.lossDate'),
        )
          ? !isEmpty(get(props.transactionInfo, 'tutorInfo', {}))
          : true) &&
        (isEmpty(corpoRegulation) || openRegulation) && (
          <RegulationCard
            listings={props.listings}
            isReadOnly={false}
            offerInfo={{
              ...get(props.transactionInfo, 'transactionQuotation'),
              ...getEvaluationByKey(
                get(
                  props.transactionInfo,
                  'transactionQuotation.evaluationKey',
                ),
                props.dahirAmount,
              ),
            }}
            sagisClaim={props.sagisInfo}
            victimInfo={get(props.transactionInfo, 'victim', {})}
            responsabilitySharedRate={get(
              getEvaluationByKey(
                get(
                  props.transactionInfo,
                  'transactionQuotation.evaluationKey',
                ),
                props.dahirAmount,
              ),
              'responsibilityRate',
            )}
            requestCreateCorporealRegulation={
              props.requestCreateCorporealRegulation
            }
            regulations={props.regulations}
            requestGetRegulations={props.requestGetRegulations}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            transactionInfo={props.transactionInfo}
            requestGetRegulation={props.requestGetRegulation}
            requestValidateRegulation={props.requestValidateRegulation}
            claimNumber={props.claimNumber}
            isConsultation={props.isConsultation}
            corpoRegulation={corpoRegulation}
            allCorpoRegulations={corpoRegulation}
          />
        )}
      {!isEmpty(get(props.transactionInfo, 'transactionQuotation', {})) &&
        (isMinorVictim(
          get(props.transactionInfo, 'victim'),
          get(props.claimInfo, 'claim.lossDate'),
        )
          ? !isEmpty(get(props.transactionInfo, 'tutorInfo', {}))
          : true) &&
        !isEmpty(corpoRegulation) &&
        corpoRegulation?.map((el: any) => (
          <RegulationCard
            listings={props.listings}
            isReadOnly={false}
            offerInfo={{
              ...get(props.transactionInfo, 'transactionQuotation'),
              ...getEvaluationByKey(
                get(
                  props.transactionInfo,
                  'transactionQuotation.evaluationKey',
                ),
                props.dahirAmount,
              ),
            }}
            sagisClaim={props.sagisInfo}
            victimInfo={get(props.transactionInfo, 'victim', {})}
            responsabilitySharedRate={get(
              getEvaluationByKey(
                get(
                  props.transactionInfo,
                  'transactionQuotation.evaluationKey',
                ),
                props.dahirAmount,
              ),
              'responsibilityRate',
            )}
            requestCreateCorporealRegulation={
              props.requestCreateCorporealRegulation
            }
            regulations={props.regulations}
            requestGetRegulations={props.requestGetRegulations}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            transactionInfo={props.transactionInfo}
            requestGetRegulation={props.requestGetRegulation}
            requestValidateRegulation={props.requestValidateRegulation}
            claimNumber={props.claimNumber}
            isConsultation={props.isConsultation}
            corpoRegulation={el}
            allCorpoRegulations={corpoRegulation}
          />
        ))}
    </>
  );
};
export default injectIntl(OfferRegulation);
